import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CustomTableComponent, DataColumnType, ICustomTable, IHeader } from 'lib-base';
import { PortalUsuarioEmpresaService } from '../../../services/database/portal-usuario-empresa.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IGetPortalUsuarioEmpresa } from '../../../shared/interfaces/database/seguridad';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-portal-usuario-empresa',
  standalone: true,
  imports: [CustomTableComponent, TranslateModule],
  template: `
    <custom-table [config]="customTable">
    </custom-table>
  `
})
export class PortalUsuarioEmpresaComponent implements OnInit {
  @Input() portalUsuarioId !: number;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private readonly _pu: PortalUsuarioEmpresaService, private readonly _t: TranslateService) { }

  ngOnInit(): void {
    this.translate().then(() => this.configTable());
    this.getPortalUsuarioEmpresa();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      correo: this._t.get('common.correo'),
      direccion: this._t.get('common.direccion'),
      nit: this._t.get('common.nit'),
      nombre: this._t.get('common.nombre'),
      telefono: this._t.get('common.telefono'),
      activo: this._t.get('common.activo'),
      empresa: this._t.get('common.empresa')
    }));
  }

  private configTable() {
    this.customTable = {
      header: {
        title: this.trans.empresa,
        class: 'title font-roboto-condensed font-18 title-blue text-uppercase font-normal mb-0',
      } as IHeader,
      columns: [
        {
          field: 'nit',
          header: this.trans.nit,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'nombre',
          header: this.trans.nombre,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'correo',
          header: this.trans.correo,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'direccion',
          header: this.trans.direccion,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'telefono',
          header: this.trans.telefono,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'activo',
          header: this.trans.activo,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.CHECK
        },
      ],
    } as ICustomTable;
  }

  private getPortalUsuarioEmpresa() {
    this._pu.getPortalUsuarioEmpresa(this.portalUsuarioId).subscribe((data: IGetPortalUsuarioEmpresa[]) => {
      this.customTableComponent.data = data;
    });
  }
}
